<template>
  <div class="fb-url-container">
    <div class="url-img" v-lazy:background-image="image" :key="image"></div>
    <div class="right-container">
      <div class="right-title">{{ title }}</div>
      <div class="right-msg">{{ msg }}</div>
      <div class="right-url">{{ fbUrl }}</div>
    </div>
    <div class="close-icon" @click="closeClick" v-if="!readonly"></div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  CURRENT_USER_INFO_SIMPLE,
  CURRENT_PUBLISHER_SIMPLE,
} from "../../../store/mutation-types";
import { getFbUrl } from "../../../service/post";
import { showErrorMsg } from "../../../utils/errors";
export default {
  name: "FbUrl",
  computed: {
    ...mapGetters({
      user: CURRENT_USER_INFO_SIMPLE,
      publisher: CURRENT_PUBLISHER_SIMPLE,
    }),
    title() {
      if (this.loading) {
        return "Loading";
      } else {
        if (this.info.error) {
          return "Error";
        } else {
          return this.info.title;
        }
      }
    },
    image() {
      if (this.loading) {
        return "";
      } else {
        if (this.info.image) {
          return this.info.image[0].url;
        } else {
          return "";
        }
      }
    },
    msg() {
      if (this.loading) {
        return "";
      } else {
        if (this.info.description) {
          return this.info.description;
        } else {
          return "";
        }
      }
    },
  },
  props: {
    url: {
      // fb的url
      type: String,
      default: "",
    },
    readonly: {
      // 详情使用 没有关闭按钮
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      fbUrl: "",
      info: {},
    };
  },
  methods: {
    closeClick() {
      this.$emit("close");
    },
  },
  watch: {
    url: {
      async handler(val) {
        const _this = this;
        // 清空url 或者当前url和之前相同则不进行更新
        if (val && val !== this.fbUrl) {
          this.fbUrl = val;
          _this.loading = true;
          try {
            const response = await getFbUrl({ url: this.fbUrl });
            _this.$set(_this, "info", response);
            if (response.type === "OAuthException") {
              try {
                await this.$confirm.show({
                  title: "Verify Facebook",
                  text: "Please login and verify your Facebook again to continue.",
                  yesText: "Login",
                  cancelText: "Cancel",
                  showClose: false,
                });
                if (this.publisher.socialNetwork === 2) {
                  this.$bus.$emit("showAddFacebookPage", {});
                } else if (this.publisher.socialNetwork === 3) {
                  this.$bus.$emit("showAddFacebookGroup", {});
                }
              } catch (e) {
                console.log(e);
              }
            }
          } catch (e) {
            showErrorMsg(e);
          } finally {
            _this.loading = false;
          }
        }
      },
      immediate: true,
    },
  },
};
</script>

<style lang="less" scoped>
.fb-url-container {
  padding: 10px;
  border: 1px solid #e5e5e5;
  margin: 5px 20px 20px 20px;
  display: flex;
  position: relative;
  .url-img {
    height: 50px;
    width: 50px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
  }
  .right-container {
    flex: 1;
    line-height: 1;
    padding-left: 10px;
    justify-content: center;
    display: flex;
    flex-direction: column;
    padding-right: 20px;
    .right-title {
      font-weight: 600;
      font-size: 16px;
    }
    .right-msg {
      font-size: 13px;
      margin-top: 10px;
      line-height: 1.2;
    }
    .right-url {
      font-size: 12px;
      color: #b6b6b6;
      margin-top: 7px;
    }
  }
  .close-icon {
    width: 12px;
    height: 12px;
    background-image: url("../../../../public/images/login/Close@3x.png");
    position: absolute;
    top: 10px;
    right: 10px;
    background-size: contain;
    cursor: pointer;
    &:hover {
      opacity: 0.7;
    }
  }
}
</style>
